<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Variant Orders/Receipt List
      </div>
      <v-spacer> </v-spacer>

      <v-btn
        small
        color="primary"
        class="mr-6"
        v-if="checkPermission('app_sku_variant:b2b_inbound_variant_upload')"
        @click="$router.push('add-variant-order/0')"
        >Add Variant Orders/Receipt</v-btn
      >
    </div>

    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col
                cols="12"
                sm="3"
                v-if="
                  $store.getters.user.user_category === 3 ||
                  $store.getters.user.user_category === 6
                "
              >
                <v-autocomplete
                  outlined
                  v-model="selectedClient"
                  :items="clients"
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  @focus="fetchClientList"
                  @input="fetchVendor(client)"
                  @change="fetchReceipts"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="receipt_key"
                  label="Receipt Key"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  outlined
                  v-model="parent_receipt_no"
                  :items="parent_receipt_nos"
                  dense
                  chips
                  small-chips
                  item-text="receipt_no"
                  item-value="id"
                  label="Parent Receipt No"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="receipt_no"
                  label="Receipt Number"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                class="pr-6"
                :class="[userCategory.user_category === 1 ? '' : 'offset-md-6']"
              >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="green"
                  style="float: right"
                  dark
                  class="mr-3"
                  @click="listPage"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                >
                  Uploaded List
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.client`]="{ item }">
        <span v-if="item.client">{{ item.client }}</span>
        <span v-else>--</span>
      </template>

      <template v-slot:[`item.parent_inbound_id__receipt_no`]="{ item }">
        <span
          ><a @click="goToInbound(item)">{{
            item.parent_inbound_id__receipt_no
          }}</a></span
        >
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ getstatus(item.status) }}</span>
      </template>
      <template v-slot:[`item.RECEIVED_QTY`]="{ item }">
        <span>{{ getData(item, "RECEIVED_QTY") }}</span>
      </template>
      <template v-slot:[`item.EXPECTED_QTY`]="{ item }">
        <span>{{ getData(item, "EXPECTED_QTY") }}</span>
      </template>
      <template v-slot:[`item.client_id__name`]="{ item }">
        {{ item.client_id__name }} <br />
        <span v-if="item.parent_storer_key || item.child_storer_key"
          >({{ item.parent_storer_key }} - {{ item.child_storer_key }})</span
        >
      </template>
      <template v-slot:[`item.created`]="{ item }">
        <span v-if="item.uae_time_created">
          {{
            item.uae_time_created
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        <span v-if="item.uae_time_updated">
          {{
            item.uae_time_updated
              | localMomentNew
              | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{
            item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}</span
        >
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.delivery_date`]="{ item }">
        <span v-if="item.delivery_date">{{
          item.delivery_date | localMoment | moment("DD MMM, YYYY ")
        }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="open(item)"
            >
              mdi-eye-outline
            </v-icon>
          </template>
          <span>Order Details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openTimeline(item)"
            >
              mdi-clipboard-text-clock-outline
            </v-icon>
          </template>
          <span>Timeline Summary</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="checkPermission('app_sku_variant:b2b_inbound_variant_edit')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openAddVariant(item)"
            >
              mdi-plus
            </v-icon>
          </template>
          <span>Add</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openDialog(item)"
              v-if="
                checkStatus(item) &&
                checkPermission('app_infor:inbound_receive') &&
                (userCategory.user_category == 3 ||
                  userCategory.user_category == 6)
              "
            >
              mdi-call-received
            </v-icon>
          </template>
          <span>Receive Order</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogItem"
      max-width="650px"
      @keydown.esc="dialogItem = false"
      scrollable
    >
      <v-card>
        <v-card-title class="px-4">
          <span class="headline">
            Order Details- {{ itemFound.receipt_no }}</span
          >
          <v-spacer></v-spacer>
          <v-icon
            @click="
              dialogItem = false;
              tableDataItems = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="px-0">
          <v-data-table
            :headers="headersItems"
            :items="tableDataItems"
            :server-items-length="totalDetails"
            :items-per-page="25"
            item-key="id"
            must-sort
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template>
      <v-row justify="center">
        <v-dialog v-model="timelinePopup" scrollable width="500">
          <v-card>
            <v-card-title style="display: inline"
              >Timeline Summary - {{ selectedItem.receipt_no }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px">
              <template>
                <div
                  class="history-tl-container-order pl-6"
                  v-for="data in trackingDetails"
                  :key="data"
                >
                  <ul class="tl p-0 mb-0">
                    <li class="tl-item" ng-repeat="item in history">
                      <!-- <v-icon class="icon-inside"
                          >mdi-truck-delivery-outline</v-icon
                        > -->
                      <div class="vertical-line">
                        <v-icon class="icon">mdi-timelapse</v-icon>
                      </div>

                      <div cols="12" md="12">
                        <div class="timestamp">
                          {{
                            data.created_at
                              | localMomentNew
                              | moment("DD MMM, YYYY hh:mm A")
                          }}
                          <br />
                        </div>
                        <div class="timestamp mt-5" v-if="data.created_by">
                          ({{ data.created_by }})
                        </div>

                        <br />
                      </div>
                      <div cols="12" md="12">
                        <div class="item-detail">
                          {{ data.message }}
                        </div>
                        <br />
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="d-flex justify-end">
              <v-btn
                color="white"
                variant="text"
                @click="(timelinePopup = false), (this.selectedItem = {})"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to receive this order'"
      :loader="statusLoader"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  computed: {
    ...mapGetters(["userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },

    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3 &&
          this.userCategory.user_category !== 6
          ? i.value !== "client"
          : true;
      });
    },
  },
  data: () => ({
    dialogConfirm: false,

    timelinePopup: false,
    parent_receipt_nos: [],
    parent_receipt_no: null,
    receipt_key: null,
    receipt_no: null,
    receipt: null,
    receipts: [],
    received_by: null,
    date: null,
    dateMenu: false,
    adddialog: false,
    openMessage: false,
    detailsData: [],
    tableDetailsItems: [],

    totalDetails: 0,
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    dialogItem: false,
    listloader: false,
    iconLoader: false,
    isloading: false,
    subTableDataStatus: null,
    subTableDataCreated: null,
    headersItems: [
      {
        text: "Client Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Variant SKU",
        value: "variant_sku_code",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "LOC",
        value: "loc",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 100,
      },
      {
        text: "LPN Number",
        value: "lpn_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Pallet LPN",
        value: "pallet_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Received Quantity",
        value: "received_quantity",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Short Quantity",
        value: "short_quantity",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Excess Quantity",
        value: "excess_quantity",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Damaged / Rejected Quantity",
        value: "rejected_quantity",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Receipt Date",
        value: "receipt_date",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },

      {
        text: "Received By",
        value: "received_by",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },

      {
        text: "Labelled Status",
        value: "labelling_status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
    ],
    detailsHeaders: [
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Client (Parent Storer - Child Storer)",
        value: "client_id__name",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "150px",
      },
      {
        text: "Parent Receipt No.",
        value: "parent_inbound_id__receipt_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Receipt No.",
        value: "receipt_no",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Receipt Key",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Parent Expected Quanity",
        value: "EXPECTED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Parent Received Quanity",
        value: "RECEIVED_QTY",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Received Quantity",
        value: "received_quantity_sum",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity_sum",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Short Quantity",
        value: "short_quantity_sum",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Excess Quantity",
        value: "excess_quantity_sum",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Labelled Status Count",
        value: "labelling_status_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },
      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "120px",
      },

      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",

        sortable: false,
      },
    ],
    carriers: [],
    isTableloading: false,
    itemCalled: false,
    sku: null,
    client: null,
    loading: false,
    list: [],
    listLoader: false,
    filtersArr: {},
    total: 0,
    options: {},
    categories: [],
    categoryLoader: false,
    category: "",
    downloader: false,
    dialog: false,
    file: null,
    selectedClient: null,
    clients: [],

    fileLoader: false,
    statusList: [],
    vendorInvoiceNumber: "",
    selectedStatus: "",
    headersArr: [
      { text: "ID", value: "id" },
      { text: "SKU", value: "sku" },
      { text: "Quantity", value: "quantity" },
      { text: "Pending Quantity", value: "pending_quantity" },
      { text: "Rejected Quantity", value: "rejected_quantity" },
    ],
    subTableHeaders: [
      { text: "SKU", value: "sku", align: "center", sortable: false },
      { text: "Status", value: "status", align: "center", sortable: false },
      {
        text: "Boe Number",
        value: "boe_number",
        align: "center",
        sortable: false,
      },
      {
        text: "Batch Code",
        value: "batch_code",
        align: "center",
        sortable: false,
      },
      { text: "Coo", value: "coo", align: "center", sortable: false },

      {
        text: "Created at",
        value: "created",
        align: "center",
        sortable: false,
      },
      {
        text: "Received Quantity",
        value: "quantity",
        align: "center",
        sortable: false,
      },
      {
        text: "Pending Quantity",
        value: "pending_quantity",
        align: "center",
        sortable: false,
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity",
        align: "center",
        sortable: false,
      },
    ],
    tableData: [],
    totals: 0,
    syncButton: false,
    expand: [],
    purchase_order_code: "",
    vendor_code: "",
    expanded: [],
    tableDataItems: [],
    selectedGrn: "",
    expandedRow: null,
    itemFound: {},
    downloaderRow: false,
    selectedItem: {},
    selectedItemVariant: {},
    trackingDetails: {},
    subheader: [
      {
        text: "Sku",
        value: "sku",
        width: "200",
      },
      {
        text: "Quantity",
        value: "quantity",
        width: "100",
      },
      {
        text: "Pending Quantity",
        value: "pending_quantity",
        width: "100",
      },
      {
        text: "Rejected Quantity",
        value: "rejected_quantity",
        width: "100",
      },
    ],
    statues: [],
    client_receive_enabled: [],
  }),

  async created() {
    await this.fetchClientList().then(() => {
      if (this.$route.query.id)
        this.selectedClient = Number(this.$route.query.id);
    });
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.fetchVendor();
      this.fetchReceipts();
    }
    if (this.$route.query.id && this.$store.getters.user.user_category !== 1) {
      await this.fetchReceipts();
      this.parent_receipt_no = Number(this.$route.query.key);
      this.searchAll();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page != 1) this.open();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "inboundVarientSummary",
      "fetchClient",
      "getVendorsList",
      "getItemDetails",

      "getVendorsLists",
      "inboundTimelineSummary",
      "getReceiptNumber",
      "uploadReceipt",
      "getInboundList",
      "inboundReceive",
    ]),
    goToInbound(item) {
      window.open(
        this.$router.resolve({
          name: "InboundList",
          query: {
            parent_id: item.parent_inbound_id__receipt_no,
            id: item.client_id_id,
          },
        }).href,
        "_blank"
      );
    },
    closeConfirm() {
      this.dialogConfirm = false;
      this.selectedItemVariant = {};
    },
    openDialog(item) {
      this.selectedItemVariant = item;
      this.dialogConfirm = true;
    },
    confirmAction() {
      this.dialogConfirm = false;
      this.isloading = true;
      let payload = {
        id: this.selectedItemVariant.id,
        request_type: "inbound_variant",
      };
      this.inboundReceive(payload)
        .then((response) => {
          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.isloading = false;

          this.fetchList();
        })
        .catch(() => {
          this.isloading = false;
          this.dialogConfirm = false;
        });
    },
    getData(e, type) {
      let searchKey = e.parent_inbound_id__receipt_key;
      if (this.tableDetailsItems.length > 0) {
        let result = this.tableDetailsItems.find(
          (item) => item.RECEIPTKEY === searchKey
        );
        if (result !== undefined && result !== null && result !== "") {
          if (type == "RECEIVED_QTY") {
            return this.changeNumberFormat(result.RECEIVED_QTY);
          } else if (type == "EXPECTED_QTY") {
            return this.changeNumberFormat(result.EXPECTED_QTY);
          } else {
            return "--";
          }
        } else {
          return "--";
        }
      } else {
        return "--";
      }
    },

    openTimeline(item) {
      this.selectedItem = item;

      this.inboundTimelineSummary(item.id).then((res) => {
        this.trackingDetails = res.data;
        this.timelinePopup = true;
      });
    },

    reset() {
      this.adddialog = false;
      this.$refs.form.reset();
      this.file = null;
    },
    fetchReceipts() {
      if (this.selectedClient) {
        let payload = {
          client_id: this.selectedClient,
        };
        this.getReceiptNumber(payload).then((res) => {
          this.parent_receipt_nos = res.data;
        });
      }
    },
    downloadRow(id) {
      this.downloaderRow = true;
      this.downloadInboudOrderRow(id)
        .then((res) => {
          this.fileDownload(res);
          this.downloaderRow = false;
          this.snackBar({
            color: "success",
            message: "file download successfully",
          });
        })
        .catch(() => {
          this.downloaderRow = false;
        });
    },
    openAddVariant(item) {
      this.$router.push({
        name: "addVariantOrder",
        params: {
          id: item.id,
        },
      });
    },
    async openError(item) {
      this.item = item;
      if (this.item == undefined) return;
      let data = {
        excel_id: this.item.excel_upload,
      };
      await this.getMessageRes({ ...data, ...this.optionsDetails }).then(
        (res) => {
          this.detailsData = res.data.records;
          this.totals = res.data.total;
          this.openMessage = true;
        }
      );
    },

    getstatus(status) {
      for (const [key, value] of Object.entries(this.statues)) {
        if (key == status) return value;
      }
    },
    async open(item) {
      if (item == undefined) {
        this.itemCalled = false;
      } else {
        this.itemCalled = true;
        this.itemFound = item;
      }

      this.getInboundList({
        inbound_variant_id: item.id,
      })
        .then((res) => {
          this.prieceLoader = false;
          this.tableDataItems = res.data.records;

          this.totalDetails = res.data.total;
          this.dialogItem = true;
        })
        .catch(() => {
          this.prieceLoader = false;
        });
    },

    download() {
      this.downloader = true;
      this.allFilters();
      this.downloadSkuList({ ...this.filtersArr }).then((res) => {
        this.fileDownload(res);
        this.downloader = false;
      });
    },
    clearDateInput(from) {
      if (from == "from_date") {
        this.from_date = null;
      } else {
        this.to_date = null;
      }
    },
    clearAll() {
      this.filtersArr = {};
      this.parent_receipt_no = null;
      this.selectedClient = null;
      this.receipt_key = "";
      this.receipt_no = "";
      this.fetchList();
    },
    callFunction(user_id) {
      this.getVendorsLists(user_id)
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },
    fetchVendor(id) {
      if (id !== null && id !== undefined && id !== "") {
        this.vendorLoader = true;
        if (
          this.userCategory.user_category == 3 ||
          this.userCategory.user_category == 6
        ) {
          this.callFunction(id);
        }
      } else {
        if (this.userCategory.user_category == 1) {
          this.callFunction(this.$store.getters.user.id);
        }
      }
    },
    async fetchClientList() {
      if (
        this.clients.length === 0 &&
        (this.$store.getters.user.user_category === 3 ||
          this.$store.getters.user.user_category === 6)
      ) {
        this.clientLoader = true;

        await this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          variant: "1",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    allFilters() {
      this.clientsLoader = true;

      let obj = {
        client_id: this.selectedClient,
        parent_receipt_no: this.parent_receipt_no,
        receipt_key: this.receipt_key
          ? this.receipt_key.trim()
          : this.receipt_key,
        receipt_no: this.receipt_no ? this.receipt_no.trim() : this.receipt_no,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    listPage() {
      this.$router.push({
        name: "skuvariantStatusList",
        params: {
          type: "inbound_variant_upload",
        },
      });
    },

    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.inboundVarientSummary({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.tableDetailsItems = res.data.records3;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    checkStatus(data) {
      return this.client_receive_enabled.some(
        (item) => item === data.client_id_id
      );
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.inboundVarientSummary({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.statues = res.data.status_mapping;
          this.tableDetailsItems = res.data.records3;
          this.total = res.data.total;
          this.client_receive_enabled = res.data.client_receive_enabled;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient.id);
      }
      this.uploadSku(payload)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$refs.form.reset();
          this.dialog = false;
          this.fileLoader = false;
        })
        .catch(() => {
          this.dialog = false;
          this.$refs.form.reset();
          this.fileLoader = false;
        });
    },
    sync() {
      this.syncButton = true;
      this.syncInboundOrder(this.client)
        .then((res) => {
          this.syncButton = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchList();
        })
        .catch(() => {
          this.syncButton = false;
        });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
/* Styles for the loader wrapper */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}

/* Styles for the loader itself */
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}

/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Styles to hide the content when the loader is active */
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.v-data-table.elevation-1.custom-padding.theme--light tbody tr td.text-start {
  padding: 0 !important;
}

.layout.wrap.pt-3 {
  padding-left: 38px !important;
}
.card-title {
  padding-left: 22px;
}
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}
.tl-item {
  margin: 0;
  padding: 0;
}
.v-timeline
  cutom-timeline
  v-timeline--align-top
  v-timeline--dense
  theme--light::before {
  left: 13px !important;
  right: 25px !important;
  top: auto !important;
}
.custom-timeline .wrap {
  padding-left: 5px;
  padding-left: 0px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 9px !important;
  right: 25px !important;
  top: auto !important;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 55px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}

.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  /* // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px; */
  line-height: 1px;
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  height: 40px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 14px;
  text-align: center;
}
.badge-force {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 92px;
  font-size: 12px;
  text-align: center;
}
</style>
